import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import moment from 'moment-timezone';
import keyGenerator from 'utils/keys';

import {
  actions as orderActions,
  selectors as orderSelector,
  selectorsByType,
} from 'state/order';
import { selectors as warningsSelectors } from 'state/warnings';

import DateField from 'components/form/RecurringForm/components/DatesRangeSelector/DateField/component';

const getValueByType = {
  start_from: (state, typeOfOrder) =>
    selectorsByType.range[typeOfOrder].getRangeFrom(state),
  end_on: (state, typeOfOrder) =>
    selectorsByType.range[typeOfOrder].getRangeTo(state),
};

const getMinValue = {
  start_from: () => moment().add(1, 'day').startOf('day').toDate(),
  end_on: (state, typeOfOrder) =>
    selectorsByType.range[typeOfOrder].getRangeFrom(state)
      ? moment(selectorsByType.range[typeOfOrder].getRangeFrom(state))
          .add(7, 'day')
          .startOf('day')
          .toDate()
      : moment().add(8, 'day').startOf('day').toDate(),
};

const getMaxValue = {
  start_from: () => moment().add(1, 'year').startOf('day').toDate(),
  end_on: (state, typeOfOrder) =>
    selectorsByType.range[typeOfOrder].getRangeFrom(state)
      ? moment(selectorsByType.range[typeOfOrder].getRangeFrom(state))
          .add(1, 'year')
          .startOf('day')
          .toDate()
      : moment().add(1, 'year').startOf('day').toDate(),
};

const enhance = compose(
  connect(
    (state, { type }) => {
      const typeOfOrder = orderSelector.getTypeOfOrder(state);
      return {
        minDate: getMinValue[type](state, typeOfOrder),
        maxDate: getMaxValue[type](state, typeOfOrder),
        value: getValueByType[type](state, typeOfOrder),
        hasError:
          warningsSelectors.getWarnings(state)[keyGenerator.recurring.range()],
      };
    },
    {
      setDate: orderActions.setRange,
    }
  ),
  withHandlers(() => {
    let responsiveModalRef = React.createRef();
    return {
      responsiveModalRef: () => (ref) => {
        responsiveModalRef = ref;
      },
      handleChange:
        ({ setDate, type, minDate, maxDate }) =>
        (value, _, e) => {
          e.stopPropagation();
          e.preventDefault();

          if (+minDate >= +value || +maxDate <= +value) return;

          try {
            const date = value.toISOString().split('T')[0];
            setDate({ type, value: date });
            responsiveModalRef.close();
          } catch (err) {
            console.error('ERROR', err);
          }
        },
    };
  })
);

export default enhance(DateField);
